const ASC_SORT_DIR = 1;
const DESC_SORT_DIR = -1;
const FOCUSABLE_SELECTOR = 'input, select, textarea, button, object, a[href], [tabindex]';

const getSortItemName = (item) => item?.name || item?.id || item?.field || null;

export const normalizeSortDirection = (dir) => {
  const text = typeof dir === 'string' ? dir.trim().toLowerCase() : null;
  if (dir === ASC_SORT_DIR || dir === '1' || text === 'asc') {
    return ASC_SORT_DIR;
  }
  if (dir === DESC_SORT_DIR || dir === '-1' || text === 'desc') {
    return DESC_SORT_DIR;
  }
  return undefined;
};

export const normalizeSortInfo = (sortInfo) => {
  if (!sortInfo) {
    return null;
  }

  const list = Array.isArray(sortInfo) ? sortInfo : [sortInfo];
  const used = new Set();
  const normalized = list
    .map((item) => {
      if (!item) {
        return null;
      }

      const name = getSortItemName(item);
      const dir = normalizeSortDirection(item.dir);
      if (!name || dir === undefined || used.has(name)) {
        return null;
      }

      used.add(name);
      return {
        ...item,
        name,
        dir,
      };
    })
    .filter(Boolean);

  if (!normalized.length) {
    return null;
  }

  return normalized;
};

export const toggleSortDirection = (dir) => {
  const normalized = normalizeSortDirection(dir);
  return normalized === ASC_SORT_DIR ? DESC_SORT_DIR : ASC_SORT_DIR;
};

export const shouldIgnoreHeaderSortClick = (event) => {
  if (event?.defaultPrevented) {
    return true;
  }

  const target = event?.target;
  if (!target || typeof target.closest !== 'function') {
    return false;
  }

  return Boolean(target.closest(FOCUSABLE_SELECTOR));
};

export const reduceSortInfoOnHeaderClick = (previousSortInfo, {columnName, shiftKey, defaultDir = ASC_SORT_DIR} = {}) => {
  const list = normalizeSortInfo(previousSortInfo) || [];
  if (!columnName) {
    return list.length ? list : null;
  }

  const existingIndex = list.findIndex((item) => item.name === columnName);
  const existingItem = existingIndex >= 0 ? list[existingIndex] : null;
  const normalizedDefaultDir = normalizeSortDirection(defaultDir);
  const nextDir = existingItem
    ? toggleSortDirection(existingItem.dir)
    : (normalizedDefaultDir === undefined ? ASC_SORT_DIR : normalizedDefaultDir);

  if (shiftKey) {
    if (existingItem) {
      return list.map((item, index) => (
        index === existingIndex
          ? {
            ...item,
            name: columnName,
            dir: nextDir,
          }
          : item
      ));
    }

    return [
      ...list,
      {name: columnName, dir: nextDir},
    ];
  }

  return [{
    ...(existingItem || {}),
    name: columnName,
    dir: nextDir,
  }];
};

export {
  ASC_SORT_DIR,
  DESC_SORT_DIR,
};
